import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AccordionModule } from "primeng/accordion";
import { AutoCompleteModule } from "primeng/autocomplete";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { CarouselModule } from "primeng/carousel";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { ChipsModule } from "primeng/chips";
import { TabsModule } from 'primeng/tabs';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
// import { CodeHighlighterModule } from "primeng/codehighlighter";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ColorPickerModule } from "primeng/colorpicker";
import { ContextMenuModule } from "primeng/contextmenu";
import { DataViewModule } from "primeng/dataview";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FieldsetModule } from "primeng/fieldset";
import { FileUploadModule } from "primeng/fileupload";
// import { FullCalendarModule } from "primeng/fullcalendar";
import { GalleriaModule } from "primeng/galleria";
import { InplaceModule } from "primeng/inplace";
import { InputNumberModule } from "primeng/inputnumber";
import { InputMaskModule } from "primeng/inputmask";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
//import { InputTextareaModule } from "primeng/inputtextarea";
import { InputTextarea } from 'primeng/inputtextarea';
// import { LightboxModule } from "primeng/lightbox";
import { ListboxModule } from "primeng/listbox";
import { MegaMenuModule } from "primeng/megamenu";
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { MultiSelectModule } from "primeng/multiselect";
import { OrderListModule } from "primeng/orderlist";
import { OrganizationChartModule } from "primeng/organizationchart";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PaginatorModule } from "primeng/paginator";
import { PanelModule } from "primeng/panel";
import { PanelMenuModule } from "primeng/panelmenu";
import { PasswordModule } from "primeng/password";
import { PickListModule } from "primeng/picklist";
import { ProgressBarModule } from "primeng/progressbar";
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from "primeng/rating";
import { RippleModule } from "primeng/ripple";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SelectButtonModule } from "primeng/selectbutton";
import { SidebarModule } from "primeng/sidebar";
import { DrawerModule } from 'primeng/drawer';
import { SliderModule } from "primeng/slider";
import { SkeletonModule } from "primeng/skeleton";
import { SplitButtonModule } from "primeng/splitbutton";
import { StepsModule } from "primeng/steps";
import { TabMenuModule } from "primeng/tabmenu";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { TerminalModule } from "primeng/terminal";
import { TieredMenuModule } from "primeng/tieredmenu";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { TreeTableModule } from "primeng/treetable";
import { TimelineModule } from 'primeng/timeline';
import { BadgeModule } from 'primeng/badge';
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { ScrollerModule } from "primeng/scroller";
import { SelectModule } from "primeng/select";
import { DividerModule } from 'primeng/divider';
@NgModule({
        declarations: [],
        imports: [
                CommonModule,
                ToggleSwitchModule,
                AccordionModule,
                TabsModule,
                AutoCompleteModule,
                DividerModule,
                BreadcrumbModule,
                ButtonModule,
                CalendarModule,
                CardModule,
                CarouselModule,
                ChartModule,
                CheckboxModule,
                ChipsModule,
                ConfirmDialogModule,
                ColorPickerModule,
                ContextMenuModule,
                DataViewModule,
                DialogModule,
                SelectModule,
                FieldsetModule,
                FileUploadModule,
                TableModule,
                GalleriaModule,
                InplaceModule,
                InputNumberModule,
                InputMaskModule,
                InputSwitchModule,
                InputTextModule,
                DataViewModule,
                //   InputTextareaModule,
                InputTextarea,
                ListboxModule,
                MegaMenuModule,
                MenuModule,
                MenubarModule,
                MessageModule,
                MessagesModule,
                MultiSelectModule,
                OrderListModule,
                OrganizationChartModule,
                OverlayPanelModule,
                PaginatorModule,
                PanelModule,
                PanelMenuModule,
                PasswordModule,
                PickListModule,
                ProgressBarModule,
                RadioButtonModule,
                RatingModule,
                RippleModule,
                ScrollPanelModule,
                SelectButtonModule,
                SidebarModule,
                MenuModule,
                SliderModule,
                SplitButtonModule,
                StepsModule,
                TableModule,
                TabMenuModule,
                TabViewModule,
                DrawerModule,
                TerminalModule,
                TieredMenuModule,
                ToastModule,
                ToggleButtonModule,
                ToolbarModule,
                TooltipModule,
                TreeModule,
                TreeTableModule,
                ScrollerModule,
                TimelineModule,
                BadgeModule,
                ProgressSpinnerModule,
                SkeletonModule
        ],
        exports: [
                CommonModule,
                AccordionModule,
                TabsModule,
                AutoCompleteModule,
                BreadcrumbModule,
                ButtonModule,
                CalendarModule,
                CardModule,
                CarouselModule,
                ChartModule,
                CheckboxModule,
                ChipsModule,
                ConfirmDialogModule,
                ColorPickerModule,
                ContextMenuModule,
                DataViewModule,
                TableModule,
                DialogModule,
                SelectModule,
                DataViewModule,
                FieldsetModule,
                FileUploadModule,
                ListboxModule,
                GalleriaModule,
                InplaceModule,
                InputNumberModule,
                InputMaskModule,
                InputSwitchModule,
                InputTextModule,
                DrawerModule,
                DividerModule,
                // InputTextareaModule,
                MegaMenuModule,
                MenuModule,
                MenubarModule,
                MessageModule,
                MessagesModule,
                MultiSelectModule,
                OrderListModule,
                OrganizationChartModule,
                OverlayPanelModule,
                PaginatorModule,
                PanelModule,
                PanelMenuModule,
                PasswordModule,
                PickListModule,
                ProgressBarModule,
                RadioButtonModule,
                RatingModule,
                RippleModule,
                ScrollPanelModule,
                SelectButtonModule,
                SidebarModule,
                // SlideMenuModule,
                SliderModule,
                SplitButtonModule,
                StepsModule,
                TableModule,
                TabMenuModule,
                TabViewModule,
                TerminalModule,
                TieredMenuModule,
                ToastModule,
                ToggleButtonModule,
                ToolbarModule,
                TooltipModule,
                TreeModule,
                TreeTableModule,
                ToggleSwitchModule,
                // VirtualScrollerModule,
                ScrollerModule,
                TimelineModule,
                BadgeModule,
                ProgressSpinnerModule,
                SkeletonModule
        ],
})
export class PrimengModule { }
